import React, { useEffect, useState } from 'react'
import Sidebaar from '../Component/Sidebar'
import { Form } from 'react-bootstrap'
import TitleComp from '../Component/TitleComp'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from 'axios';
import { Base_Url } from '../BaseUrl';
import { ToastContainer, toast } from 'react-toastify';
import { Bars } from 'react-loader-spinner';

function AboutUs() {
    const [description, setdescription] = useState("");
    const [policy, setpolicy] = useState("");
    const [loading, setloading] = useState(false)
    // const [main, setmain] = useState([])
    const [edit, setedit] = useState("")
    const [name, setname] = useState("")

    const [data, setdata] = useState([])

    let token = localStorage.getItem("token")

    const headers = {
        Authorization: `Bearer ${token}`
    }

    const handlepolicy = () => {

        axios.get(`${Base_Url}/static_pages`, { headers }).then((res) => {
            setdata(res.data.data)
        })
    }

    const filter = () => {
        if (policy != "") {
            let res = data.filter((item) => item._id == policy)
            console.log("gilter", res?.[0])
            setname(res?.[0].name)
            setedit(res?.[0]._id)

            setdescription(res?.[0].content)
        }
    }

    useEffect(() => {
        filter()
    }, [policy])

    useEffect(() => {
        handlepolicy()
    }, [])


    const handleSubmit = (e) => {
        e.preventDefault()
        setloading(true)

        let requestdata = {
            name: name,
            content: description,
            _id: edit
        }
        axios.put(`${Base_Url}/static_pages`, requestdata, { headers }).then((res) => {
            console.log(res)
            if (res.data.error == "0") {
                toast.success("Data Updated Successfully")
                handlepolicy()

            }
        }).finally(() => {
            setloading(false)
        })
    }
    return (
        <>
            <ToastContainer />
            {loading && (
                <div className="overlay">
                    <Bars
                        height="80"
                        width="80"
                        color="#051322"
                        ariaLabel="bars-loading"
                        visible={true}
                    />
                </div>
            )}
            <Sidebaar content={
                <>
                    <Form onSubmit={(e) => handleSubmit(e)}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <TitleComp title="Policy" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="">
                                    <label htmlFor="">Select Policy</label>
                                    <select name="" value={policy} onChange={(e) => setpolicy(e.target.value)} className='form-control form-select shadow-none' id="">
                                        <option value="">--Select--</option>
                                        {data.map((item) => {
                                            return (
                                                <>
                                                    <option value={item._id}>{item.name}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            {/* name
slug
content
description */}
                            <div className="col-md-4">
                                <label htmlFor="">Name</label>
                                <input type="text" required value={name} onChange={(e) => setname(e.target.value)} className='form-control' />
                            </div>

                            <div className="col-md-12">
                                <div className="mt-3">
                                    <label htmlFor="">Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setdescription(data); // Update this line
                                        }}

                                        className="custom-ckeditor"
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button className='btn bg-dark mt-4 text-white'>Submit</button>
                            </div>
                        </div>
                    </Form>
                </>
            } />
        </>
    )
}

export default AboutUs
